<template lang="html">
	<div id="page__documents" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="documents" v-on:refresh="getDocuments" 
				v-bind:per-page="count" v-bind:total="documentAmount" link table-id="documents" default-order="desc" 
				default-sort="created_at" selected-field="select" select-item-field="id" v-on:change-selected="changeSelected"
				v-bind:loadOnScroll="true" v-bind:compactHeader="true" v-bind:showAddButton="false"
				ref="documentTable"
			>
				<template slot="head" v-if="(selectedDocuments && selectedDocuments.length)">
					<z-button fit-content v-if="isUserAdmin" v-on:click="onSendClick">Отправить на E-mail</z-button>
				</template>

				<template slot="number" slot-scope="scope">
					<span>{{ getDocNumber(scope.item) }}</span>
				</template>

				<template slot="deal.traking_number" slot-scope="scope">
					<span> {{ (scope.item.deal && typeof scope.item.deal.first_freight !== 'undefined') ? scope.item.deal.first_freight.traking_number : '' }} </span>
				</template>

				<template slot="creater.login" slot-scope="scope">
					<span> {{ (scope.item.creater) ? scope.item.creater.login : '' }} </span>
				</template>

				<template slot="nds" slot-scope="scope">
					<span> {{ (scope.item.deal && scope.item.deal.executor) ? (scope.item.deal.executor.nds == '1' ? 'С НДС' : 'Без НДС') : '' }} </span>
				</template>

				<template slot="status" slot-scope="scope">
					<span> {{ scope.item.status == 'ACTUAL' ? 'Актуальный' : 'Удаленный' }} </span>
				</template>

				<template slot="created_at" slot-scope="scope">
					<span> {{ moment(scope.item.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY') }} </span>
				</template>

				<template slot="customer" slot-scope="scope">
					<span> {{ (scope.item.customer) ? scope.item.customer.name : '' }} </span>
				</template>

				<template slot="last_email" slot-scope="scope">
					<span
						class="email-status"
						v-if="scope.item.last_email"
						v-bind:class="{ sent: scope.item.last_email.success == '1', 'not-sent': scope.item.last_email.success == '0' }"
					>
						{{ (scope.item.last_email.success == '1' ? 'Доставлено' : 'Не доставлено') + ': ' + moment(scope.item.last_email.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY') + ' (' + scope.item.last_email.email + ')' }}
					</span>
				</template>
			</sort-table>
		</md-content>

		<ZDialog v-bind:active.sync="sendDocDialog">
			<template slot="title">Отправка документов</template>
			<template>
				<z-select
					id="document-recipient"
					name="document_recipient"
					label="E-mail получателя"
					v-validate="'required'"
					v-bind:error="errors.first('document_recipient')"
					v-model="documentRecipient"
				>
					<option v-for="contact in contacts" v-bind:key="contact.id" v-bind:value="contact.id"> {{ contact.email }} {{ contact.type_name ? '(' + contact.type_name + ')' : '' }} </option>
					<option value="other"> Другой... </option>
				</z-select>
				<z-input
					label="Ваш e-mail"
					v-if="documentRecipient == 'other'"
					v-model="documentRecipientOther"
					name="document_recipient_other"
					id="document-recipient-other"
					v-validate="'email|required'"
					v-bind:error="errors.first('document_recipient_other')"
					data-vv-name="document_recipient_other"
					v-bind:data-vv-as="' '"
				></z-input>
			</template>
			<template slot="actions">
				<z-button @click="sendDocDialog = false">Отмена</z-button>
				<z-button @click="sendDoc()" accent>Отправить</z-button>	
			</template>
		</ZDialog>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable";
	import ZInput    from '@/components/ZInput';
	import ZSelect   from '@/components/ZSelect';
	import ZButton   from '@/components/ZButton.vue';
	import ZDialog   from '@/components/ZDialog.vue';
	export default {
		components: { SortTable, ZInput, ZSelect, ZButton, ZDialog },
		data() {
			return {
				tableColumns: [
					{ label: '', field: 'select', width: '30px'},
					{ label: 'Дата создания', field: 'created_at', sortable: true, width: '150px'},
					{ label: 'Тип', field: 'label', sortable: true, width: '150px'},
					{ label: 'Номер документа', field: 'number', sortable: false, width: '50px'},
					{ label: 'Заявка', field: 'deal.traking_number', sortable: true, width: '100px'},
					{ label: 'Создатель', field: 'creater.login', width: '150px'},
					{ label: 'НДС', field: 'nds', width: '50px'},
					{ label: 'Контрагент', field: 'customer', sortable: true, width: '150px'},
					{ label: 'Статус', field: 'status', sortable: true, width: '150px'},
					{ label: 'Последняя отправка', field: 'last_email', width: '150px'},
					{ label: '', field: 'actions', width: '30px'},
				],
				currentPage: 1, 
				count: 50,
				selectedDocuments: [],
				sendDocDialog: false,
				documentRecipient: '',
				documentRecipientOther: '',
			}
		},
		created() {
			this.$store.commit('setTitle', 'Документы');
			this.$store.commit('setBigSizePanel');
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-document-list'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Количество документов
			 */
			documentAmount() {
				return this.$store.state.deals.document_amount
			},
			/**
			 * Мписок документов
			 */
			documents() {
				return !this.$store.state.deals.documents ? [] : this.$store.state.deals.documents.map(document => {
					document.routerLink = { name: 'Document', params: { id: document.id }, query: this.$route.query };
					return document;
				});
			},
			/**
			 * Текущий пользователь 
			 */
			user() {
				return this.$store.state.users.current;
			},
			/**
			 * Проверка прав пользователя
			 */
			isUserAdmin() {
				return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
			},
			/**
			 * 
			 */
			selectedDocumentsDeal() {
				let deal = null;
				
				if (this.selectedDocuments.length > 0) {
					const selectedDocs = this.documents.filter(document => this.selectedDocuments.includes(document.id));
					for (const selectedDocument of selectedDocs) {
						if (deal == null || deal.id == selectedDocument.deal.id) deal = selectedDocument.deal;
						else return null;
					}
				}
				return deal;
			},
			/**
			 * Список контактов
			 */
			contacts() {
				let contacts = [];

				if (this.selectedDocumentsDeal != null) {
					let members = ['sender', 'recipient', 'payer'];

					members.forEach(member => {
						if (
							typeof this.selectedDocumentsDeal[member] !== 'undefined' &&
							this.selectedDocumentsDeal[member] &&
							this.selectedDocumentsDeal[member].email &&
							this.selectedDocumentsDeal[member].email.length > 0
						) {
							contacts.push({
								id: member,
								email: this.selectedDocumentsDeal[member].email,
								name: null,
								type: member
							});
						}
					});

					this.selectedDocumentsDeal.contacts.forEach(contact => {
						if (contact.contact.email && contact.contact.email.length > 0) {
							contact.contact.type = contact.type;
							contact.contact.id = contact.id;
							contacts.push(contact.contact);
						}
					});

					contacts.forEach(contact => {
						contact.type_name = '';
						switch (contact.type) {
							case 'sender': contact.type_name = 'отправитель'; break;
							case 'recipient': contact.type_name = 'получатель'; break;
							case 'payer':
								contact.type_name = 'плательщик';
								if (contact.type == 'payer') this.documentRecipient = contact.id;
							break;
						}
					});
				}

				if (contacts.length == 0) this.documentRecipient = 'other';

				return contacts;
			}
		},
		methods: {
			/**
			 * Получение документов
			 */
			getDocuments( page, count, orderBy, orderType, filter, reload ) {
				this.$store.commit('showProgressBar', 'get-document-list');

				let params = {
					page:       (page)      ? page      : this.currentPage,
					count:      (count)     ? count     : this.count,
					order_by:   (orderBy)   ? orderBy   : 'id',
					order_type: (orderType) ? orderType : 'desc',
					filter:     this.resolveQueryFilter(),
					data:   '=',
					custom_filter: (this.$route.query && this.$route.query.custom_filter) ? JSON.parse(this.$route.query.custom_filter) : null,
					concat: !reload
				};

				return this.$store.dispatch('deals/getDocumentList', params)
					.finally(() => this.$store.commit('hideProgressBar', 'get-document-list'));
			},
            getDocNumber(doc) {
                if (!doc) return 0;
                if (doc.type !== 'bill') return doc.number;
                if (!doc.number_in_deal || parseInt(doc.number_in_deal) <= 0)
                    return doc.deal.first_freight.traking_number;

                return `${doc.deal.first_freight.traking_number}/${doc.number_in_deal}`;
            },
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)),
					model = [], result = {model: [], relation: [], condition: 'and'};

				if (filter.number)  model.push(['number',  '%', filter.number]);
                if (filter.status)  model.push(['status',  '=', filter.status]);
				if (filter.deal_id) model.push(['deal_id', '=', filter.deal_id]);
            
				model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and')
                });

				return result;
			},
			onSendClick() {
				this.sendDocDialog = true;
			},
			/**
			 * Отправка документа на почту
			 */
			sendDoc() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					const data = { documents: this.selectedDocuments };

					if (this.documentRecipient == 'other') { data.email = this.documentRecipientOther } 
					else {
						const contact = this.contacts.find(contact => contact.id == this.documentRecipient);
						data.email = contact.email;
						
						if (contact.name) data.name = contact.name;
					}
					
					this.sendDocDialog = false;

					this.$store.commit('showProgressBar', 'get-document-list');
					this.$store.dispatch('deals/sendDocumentsByEmail', data).then(r => {
						if (r.success) {
							this.$store.commit('showSnackbar', ['Документы отправлены', 10000, 'success']);
							this.$refs.documentTable.$emit('clear-selected');
						}
					}).finally(() => this.$store.commit('hideProgressBar', 'get-document-list'));
				});
			},
			/**
			 * Обновление списка выбранных документов
			 */
			changeSelected(val) {
				this.selectedDocuments = Object.assign([], val);
			},
		}
	}
</script>


// WEBPACK FOOTER //
// Documents.vue?72ba591d